@import '../../../globals/main.scss';
pn-share {
  .pn-share__container {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }

  .pn-share__heading {
    font-size: 1.6rem;
    font-weight: 500;
    &:after {
      content: '';
      display: block;
      height: 0.2rem;
      background-color: $gray50;
      margin-top: 0.4rem;
      margin-bottom: 0.8rem;
    }
  }

  .pn-share__items {
    display: flex;
    flex-direction: row;
    gap: 0.8rem;
    align-items: center;
  }
}
